<template>
  <div class="vd-gl-out">
    <div class="vd-gl-search-form">
      <a-form layout="inline">
        <a-form-item>
          <a-tooltip title="账号名称">
            <a-input
              :allow-clear="true"
              placeholder="请输入账号名称"
              v-model="searchForm.name"
            />
          </a-tooltip>
        </a-form-item>
        <a-form-item>
          <a-tooltip title="归属人">
            <a-input
              style="width: 150px"
              :allow-clear="true"
              placeholder="请输入归属人"
              v-model="searchForm.owner_name"
            />
          </a-tooltip>
        </a-form-item>
        <a-form-item>
          <a-tooltip title="工号">
            <a-input
              style="width: 150px"
              :allow-clear="true"
              placeholder="请输入工号"
              v-model="searchForm.username"
            />
          </a-tooltip>
        </a-form-item>
        <a-form-item>
          <a-tooltip title="所属地区">
            <a-cascader
              style="width: 216px"
              :options="areaTree"
              v-model="searchForm.areaPath"
              :field-names="{
                label: 'name',
                value: 'id',
                children: 'children',
              }"
              placeholder="所属地区"
              :change-on-select="true"
            />
          </a-tooltip>
        </a-form-item>
        <a-form-item>
          <a-tooltip title="所属项目">
            <a-select
              style="width: 108px"
              allowClear
              v-model="searchForm.category"
              placeholder="所属项目"
            >
              <template v-for="item in subList">
                <a-select-option :key="item.id">
                  {{ item.nickname }}
                </a-select-option>
              </template>
            </a-select>
          </a-tooltip>
        </a-form-item>
        <a-form-item>
          <a-tooltip title="时间区间">
            <a-range-picker
              style="width: 300px"
              :default-value="defaultTime"
              format="YYYY/MM/DD"
              @change="dateChange"
            />
          </a-tooltip>
        </a-form-item>
        <a-form-item>
          <a-tooltip title="账号状态">
            <a-select
              style="width: 108px"
              allowClear
              v-model="searchForm.status"
              placeholder="账号状态"
            >
              <template v-for="item in staList">
                <a-select-option :key="item.id">
                  {{ item.nickname }}
                </a-select-option>
              </template>
            </a-select>
          </a-tooltip>
        </a-form-item>
        <a-form-item>
          <a-button class="common-button" type="primary" @click="searchInfo">
            搜索
          </a-button>
          <a-button type="danger" @click="redoSearch">重置条件</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="vd-gl-content">
      <a-row type="flex" class="vd-table-head">
        <a-col flex="auto" class="vd-table-name"> 抖音账号列表</a-col>
        <a-col class="vd-table-tool">
          <a-button type="primary" icon="plus" @click="auth">
            接入账号
          </a-button>
          <a-divider type="vertical" />
          <a-tooltip title="导出数据">
            <a-icon class="common-icon" type="export" @click="exportData" />
          </a-tooltip>
          <a-tooltip
            v-if="$AuthUtil.authRoute('/tik/upd_data')"
            title="更新数据"
          >
            <a-icon class="common-icon" type="sync" @click="syncItem" />
          </a-tooltip>
        </a-col>
      </a-row>
      <!-- 内容主体 -->
      <a-table
        ref="data"
        :data-source="list"
        :loading="loading"
        :pagination="pagination"
        :scroll="{x:1500, y: tableHeight}"
        row-key="id"
        size="small"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          fixed: true
        }"
      >
        <a-table-column title="ID" data-index="id" width="50px"/>
        <a-table-column title="头像" width="150px">
          <template slot-scope="item">
            <a-avatar slot="avatar" :src="item.avatar" size="large" />
            <span> {{ item.nickname }} </span>
            <br />
            <span>地区: {{ item.name }} </span>
            <br />
            <span>项目: {{ item.category_name }} </span>
          </template>
        </a-table-column>
        <a-table-column title="截至" data-index="date" width="100px"/>
        <a-table-column title="归属人" data-index="owner_name" width="100px"/>
        <a-table-column title="工号" data-index="username" width="100px"/>
        <a-table-column title="归属组织" data-index="owner_orgname" width="140px"/>
        <a-table-column title="新增粉丝" data-index="fans_new_fans" align="center" width="70px"/>
        <a-table-column title="粉丝总数" data-index="fans_total_fans" align="center" width="70px"/>
        <a-table-column title="评论量" data-index="new_comment" align="center" width="70px"/>
        <a-table-column title="点赞量" data-index="new_like" align="center" width="70px"/>
        <a-table-column title="分享量" data-index="new_share" align="center" width="70px"/>
        <a-table-column title="主页访问量" data-index="profile_uv" align="center" width="70px"/>
        <a-table-column title="视频新增" data-index="video_new_issue" align="center" width="70px"/>
        <a-table-column title="视频播放总量" data-index="video_new_play" align="center" width="70px"/>
        <a-table-column title="视频总数" data-index="video_total_issue" align="center" width="70px"/>
        <a-table-column title="操作" align="center" width="130px" fixed="right">
          <template slot-scope="record">
            <template v-if="!$HelperUtil.isEmpty(record.message)">
              {{ record.message }}
            </template>
            <template v-else>
              <template v-if="record.status !== 2">
                <a-tooltip
                  v-if="$AuthUtil.authRoute('/tik/setting')"
                  title="设置"
                >
                  <a-icon
                    class="common-icon"
                    type="setting"
                    @click="setting(record)"
                  />
                </a-tooltip>

                <a-tooltip
                  v-if="$AuthUtil.authRoute('/tik/remove')"
                  title="删除数据"
                >
                  <a-popconfirm
                    placement="top"
                    title="是否移除绑定数据"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="deleteItem(record.id)"
                  >
                    <a-icon class="common-icon" type="delete" />
                  </a-popconfirm>
                </a-tooltip>
                <a-tooltip
                  v-if="$AuthUtil.authRoute('/tik/detail')"
                  title="详情"
                >
                  <a-icon
                    class="common-icon"
                    type="small-dash"
                    @click="detail('/tik/detail', record.id)"
                  />
                </a-tooltip>
              </template>
              <template v-else>
                <span style="color:red;">
                  超过最长授权时间<br />请重新授权
                </span>
                <a-tooltip
                  v-if="$AuthUtil.authRoute('/tik/remove')"
                  title="删除数据"
                >
                  <a-popconfirm
                    placement="top"
                    title="是否移除绑定数据"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="deleteItem(record.id)"
                  >
                    <a-icon class="common-icon" type="delete" />
                  </a-popconfirm>
                </a-tooltip>
              </template>
            </template>
          </template>
        </a-table-column>
      </a-table>
      <a-modal
        ok-text="确定"
        cancel-text="取消"
        title="抖音号信息"
        @cancel="cancel"
        @ok="confirm"
        :visible="visible"
      >
        <a-form-model
          ref="ruleForm"
          layout="horizontal"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label="所属地区" prop="areaPath">
            <a-cascader
              style="width: 216px"
              :options="areaTree"
              v-model="form.areaPath"
              :field-names="{
                label: 'name',
                value: 'id',
                children: 'children',
              }"
              placeholder="公众号所属地区"
              :change-on-select="true"
            />
          </a-form-model-item>
          <a-form-model-item label="项目" prop="category">
            <a-select
              style="width: 116px"
              allowClear
              v-model="form.category"
              placeholder="公众号项目"
            >
              <template v-for="item in subList">
                <a-select-option :key="item.id">
                  {{ item.nickname }}
                </a-select-option>
              </template>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { get_sub } from '@/api'
import { get_area_tree } from '@/api/auth'
import {
  access,
  tik_register,
  list,
  modify_list,
  tik_remove,
  upd_data,
} from '@/api/tik'
import moment from 'moment'
import XLSX from 'xlsx'

export default {
  name: 'Setting',
  data() {
    return {
      defaultTime: [
        moment()
          .startOf('day')
          .subtract(1, 'day'),
        moment()
          .endOf('day')
          .subtract(1, 'day'),
      ],
      loading: false,
      form: {
        id: undefined,
        areaPath: undefined,
        category: undefined,
      },
      rules: {
        areaPath: [
          { required: true, message: '请填写活动名称', trigger: 'blur' },
        ],
        category: [
          { required: true, message: '请填写活动名称', trigger: 'blur' },
        ],
      },
      subList: [],
      areaTree: [],
      staList:[
        {
          id: 0,
          nickname: '取消授权',
        },
        {
          id: 1,
          nickname: '连接中',
        },
        {
          id: 2,
          nickname: '授权过期',
        }
      ],
      visible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      list: [],
      selectedRowKeys: [],
      searchForm: {
        name: undefined,
        owner_name: undefined,
        username: undefined,
        areaPath: undefined,
        category: undefined,
        status: undefined,
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 50,
        pageSizeOptions: ['50', '100', '200'],
        // showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total) => {
          return '共' + total + '条'
        },
        onChange: (page, size) => {
          this.pagination.current = page
          this.pagination.pageSize = size
          this.getData()
        },
        onShowSizeChange: (page, size) => {
          this.pagination.current = page
          this.pagination.pageSize = size
          this.getData()
        }
      },
      code: '',
      login_qq: undefined,
      pageLoading: false,
      tableHeight: 50
    }
  },
  created() {
    if (!this.$HelperUtil.isEmpty(this.$route.query)) {
      // 页面loading
      this.callbackCode(this.$route.query.code)
      this.getData()
    } else {
      this.getData()
    }
    get_sub('item_type').then((res) => {
      if (res.code === 1) {
        this.subList = res.list
      }
    })
    get_area_tree().then((res) => {
      if (res.code === 1) {
        this.areaTree = res.areaTree
      }
    })
  },
  methods: {
    redoSearch() {
      this.searchForm = {
        name: undefined,
        owner_name: undefined,
        username: undefined,
        areaPath: undefined,
        category: undefined,
        status: undefined,
      }
    },
    dateChange(dates) {
      this.defaultTime = dates
    },
    // 获取数据
    getData() {
      this.loading = true
      list({
        defaultTime: this.defaultTime,
        name: this.searchForm.name,
        owner_name: this.searchForm.owner_name,
        username: this.searchForm.username,
        areaPath: this.searchForm.areaPath,
        category: this.searchForm.category,
        status: this.searchForm.status,
        current: this.pagination.current,
        pageSize: this.pagination.pageSize
      }).then((res) => {
        this.loading = false
        if (res.code === 1) {
          this.pagination.total = res.count
          this.list = res.list
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    detail(key, id) {
      this.$router.push({ path: key, query: { id: id } })
    },
    deleteItem(id) {
      tik_remove({ id: id }).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.msg)
          this.getData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    syncItem() {
      if (this.$HelperUtil.isEmpty(this.selectedRowKeys)) {
        this.$message.warning({
          content: '请选择要更新的账号',
          key: 'upd_data',
        })
        return false
      }

      // const createPromise = (id) => () =>
      //   new Promise((resolve) =>
      //     setTimeout(() => {
      //       console.log('promise->' + id + ':' + new Date())
      //       resolve()
      //     }, 1000)
      //   )
      // var tasks = [createPromise(1), createPromise(2), createPromise(3)]
      // console.log(tasks)
      // var doTask = tasks.reduce(
      //   (prev, next) => prev.then(() => next()),
      //   Promise.resolve()
      // )
      // doTask.then(() => console.log('all done.'))

      new Promise((resolve) => {
        this.list.forEach((arr, index) => {
          if (this.selectedRowKeys.includes(arr.id)) {
            upd_data({
              id: arr.id,
            }).then((res) => {
              this.list[index]['message'] = res.msg
              this.$forceUpdate()
              resolve()
            })
          }
        })
      })
    },
    setting(record) {
      this.visible = true
      this.form.id = record.id
      this.form.category =
        record.category === null ? undefined : record.category
      this.form.areaPath = record.area_path
    },
    cancel() {
      this.visible = false
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.visible = false
          modify_list({
            id: this.form.id,
            category: this.form.category,
            areaPath: this.form.areaPath,
          }).then((res) => {
            if (res.code === 1) {
              this.$message.success(res.msg)
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },
    // 搜索按钮
    searchInfo() {
      this.pagination.current = 1
      this.pagination.total = 0
      this.getData()
    },
    auth() {
      access().then((res) => {
        if (res.code === 1) {
          window.location.href = res.auth
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 导出数据
    exportData() {
      const headerDisplay = {
        nickname: '账号名称',
        name: '地区',
        category_name: '项目',
        owner_name: '归属人',
        username: '工号',
        owner_orgname:'归属组织',
        video_total_issue: '视频总条数',
        fans_total_fans: '粉丝总数',
        profile_uv: '个人主页访问量',
        new_comment: '新增评论',
        new_share: '新增分享',
        new_like: '新增点赞',
        fans_new_fans: '新增粉丝',
        video_new_play: '视频新增播放',
        video_new_issue: '视频新增条数',
      }
      const fields = [
        'nickname',
        'name',
        'category_name',
        'owner_name',
        'username',
        'owner_orgname',
        'video_total_issue',
        'fans_total_fans',
        'profile_uv',
        'new_comment',
        'new_share',
        'new_like',
        'fans_new_fans',
        'video_new_play',
        'video_new_issue',
      ]
      list({
        defaultTime: this.defaultTime,
        name: this.searchForm.name,
        owner_name: this.searchForm.owner_name,
        username: this.searchForm.username,
        areaPath: this.searchForm.areaPath,
        category: this.searchForm.category,
        status: this.searchForm.status,
        current: '',
        pageSize: ''
      }).then((res) => {
        const n_list = JSON.stringify(res.list, fields)
        const _list = JSON.parse(n_list)
        const list = [headerDisplay, ..._list]

        const ws = XLSX.utils.json_to_sheet(list, {
          header: fields,
          skipHeader: true
        })
        let workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, ws, 'data')
        XLSX.writeFile(workbook, 'tik_account_data.xlsx', {
          type: 'base64',
          bookType: 'xlsx'
        })
      })
    },
    callbackCode(code) {
      const modal = this.$info({
        title: '处理数据中~',
      })
      modal.destroy()
      tik_register({
        code: code,
      }).then((res) => {
        // 删除链接上的code参数
        if (res.code === 1) {
          this.$message.success(res.msg)
          this.$router.push({ path: '/tik/setting', replace: true })
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    blogDone(code, message) {
      let secondsToGo = 3
      if (code === 0) {
        const modal = this.$warning({
          title: message,
          content: ` ${secondsToGo} 秒后自动关闭.`,
        })
        const interval = setInterval(() => {
          secondsToGo -= 1
          modal.update({
            content: ` ${secondsToGo} 秒后自动关闭.`,
          })
        }, 1000)
        setTimeout(() => {
          clearInterval(interval)
          modal.destroy()
        }, secondsToGo * 1000)
      } else {
        const modal = this.$success({
          title: message,
          content: ` ${secondsToGo} 秒后自动关闭.`,
        })
        const interval = setInterval(() => {
          secondsToGo -= 1
          modal.update({
            content: ` ${secondsToGo} 秒后自动关闭.`,
          })
        }, 1000)
        setTimeout(() => {
          clearInterval(interval)
          modal.destroy()
        }, secondsToGo * 1000)
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
  },
  mounted:function(){
    this.$nextTick(function () {
      this.tableHeight = window.innerHeight - this.$refs.data.$el.offsetTop - 280;
      
      // 监听窗口大小变化
      let self = this;
      window.onresize = function() {
        self.tableHeight = window.innerHeight - self.$refs.data.$el.offsetTop - 280;
      }
    })
  }
}
</script>

<style scoped>
</style>
